import React, { Children } from 'react'
import { Platform, View } from 'react-native'
import { twMerge } from 'tailwind-merge'

import { columns } from '@ui-kit/components/layoutComponents/Columns/styles'

import type { NativeProps } from './types'

const Columns = (props: NativeProps): JSX.Element => {
  const { children, space, collapsable, collapsedSpace, ...viewProps } = props
  const className = columns({
    collapseOnMobile: false || collapsable,
    collapsedSpace: collapsedSpace ?? space,
    space,
  })
  return (
    <View {...viewProps} className={twMerge(className, props.className)}>
      {Children.map(children, (child) => {
        // nativewind requires that children support the style prop
        // in order to apply gap styles, so we just wrap each child in a view
        return Platform.select({
          native: <View>{child}</View>,
          web: child,
        })
      })}
    </View>
  )
}

export default Columns
